import { useTranslation } from 'react-i18next';
import Link from 'next/link';

export default function LoginReminder() {
  const { t } = useTranslation();
  return (
    <>
      <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <h1 className="my-6 text-lg leading-7 font-bold">
            {t('Please Sign In First to Take Any Action')}
          </h1>
          <p>
            To access personalized content and take actions based on your
            account history, please sign in to your account.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link
              href="/signin"
              className="btn-redesign btn-redesign-primary"
            >
              {t('sign_in_title')}
            </Link>
            <Link
              href="/signup"
              className="text-sm font-semibold text-ink-800 hover:text-brand-800"
            >
              {t('sign_up_title')} <span aria-hidden="true">&rarr;</span>
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
